import * as React from "react";

function SvgUser(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 53.001 53" {...props}>
      <path
        d="M32.5 27.826a14.208 14.208 0 10-19.664-13.09 14.249 14.249 0 008.293 12.952A26.271 26.271 0 00.5 51.431a1 1 0 001 1.069 1.006 1.006 0 001-.947 24.059 24.059 0 0148.006 0 1 1 0 101.994-.122 26.28 26.28 0 00-20-23.605zm-17.668-13.09a12.121 12.121 0 1112.12 12.22 12.184 12.184 0 01-12.12-12.22z"
        data-name="Caminho 144"
        fill="currentColor"
        stroke="#currentColor"
      />
    </svg>
  );
}

export default SvgUser;

